<template>
  <div class="services-wrap">
    <b-container>
      <div class="text-center services-head">
        <span class="services-eyebrow">Todo lo que necesitas</span>
        <h2 class="services-title">Una plataforma, todo el proceso PIE</h2>
        <p class="services-subtitle">
          Herramientas más robustas para acompañar cada etapa del Programa de
          Integración Escolar y las escuelas especiales, del decreto 170 al 83.
        </p>
      </div>

      <div v-for="group in groups" :key="group.name" class="services-group">
        <div class="group-label" :style="{ '--accent': group.color }">
          <span class="group-dot"></span>{{ group.name }}
        </div>
        <div class="services-grid">
          <div
            v-for="service in group.services"
            :key="service.name"
            class="service-card"
            :style="{ '--accent': group.color }"
          >
            <div class="service-icon">
              <b-img :src="service.img" alt="" />
            </div>
            <h3 class="service-name">{{ service.name }}</h3>
            <p class="service-desc">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
// ponytail: service list is static marketing content grouped by product area;
// edit the arrays below to add/retire a service.
const img = (name) => require(`../../../assets/img/sales/${name}`);

export default {
  name: "OurServices",
  props: {
    route: { type: String, required: false },
  },
  data() {
    return {
      groups: [
        {
          name: "Documentación PIE, online y colaborativa",
          color: "#2e9e6b",
          services: [
            {
              name: "FUDEI",
              description:
                "Trabaja el FUDEI sin compartir la clave de Comunidad Escolar. En línea, con autoguardado y en simultáneo con todo tu equipo. Guardamos los datos para que no vuelvas a escribirlos y te sugerimos textos para avanzar más rápido.",
              img: img("file-green.svg"),
            },
            {
              name: "FU de reevaluación",
              description:
                "Todos los formatos de FU de reevaluación 100% online, simultáneos y con autoguardado. Completamos automáticamente los datos del equipo de aula, establecimiento y estudiante.",
              img: img("file-yellow.svg"),
            },
            {
              name: "PACI (Decreto 83)",
              description:
                "Formato amigable de PACI ligado a los puntos obligatorios del decreto 83 (o carga el tuyo). Te facilitamos objetivos de aprendizaje, habilidades, actitudes y sugerencias de adecuaciones curriculares.",
              img: img("file-blue.svg"),
            },
            {
              name: "PAI y Estado de Avance",
              description:
                "Tus propios formatos de PAI y Estado de Avance con carga automática de la identificación del estudiante y acceso rápido a OA priorizados, actitudes e indicadores de evaluación.",
              img: img("file-red.svg"),
            },
            {
              name: "Actas y Bitácoras",
              description:
                "Guarda actas y bitácoras de todos tus cursos: trabajo con estudiantes, reuniones de equipo y citaciones de apoderados. Usa nuestras plantillas o carga las de tu colegio.",
              img: img("file-colors.svg"),
            },
          ],
        },
        {
          name: "Corrección automática de pruebas",
          color: "#b76629",
          services: [
            {
              name: "Informes Psicológicos",
              description:
                "Trabaja con el formato de tu colegio y corrige de forma automática WISC-III, WISC-V, WAIS-IV e ICAP. Obtienes análisis cuantitativo, discrepancias, fortalezas y debilidades a partir de los puntajes.",
              img: img("file-blue.svg"),
            },
            {
              name: "Informes Psicopedagógicos",
              description:
                "Corrige automáticamente Evalúa 2.0, 3.0 y 4.0, Evamat, CLPT y Precálculo. El sistema interpreta los resultados y entrega un análisis que complementas con nuestro banco de sugerencias.",
              img: img("file-red.svg"),
            },
            {
              name: "Informes Fonoaudiológicos",
              description:
                "Corrección automática de STSG expresivo y receptivo, TEPROSIF-R, TECAL, IDTEL y PEFE ingresando aciertos, errores y procesos de simplificación. Entregamos el análisis listo en tu informe.",
              img: img("file-yellow.svg"),
            },
            {
              name: "Corrector de tests con chatbot",
              description:
                "¿Solo necesitas corregir una prueba? Nuestro asistente corrige los tests estandarizados del decreto 170 sin necesidad de crear al estudiante y te entrega un informe Word combinado al instante.",
              img: img("double-check.svg"),
            },
          ],
        },
        {
          name: "Evaluación y aprendizaje",
          color: "#3577d4",
          services: [
            {
              name: "Eureka",
              description:
                "Evaluación psicopedagógica digital y validada en Chile para el diagnóstico de DEA. Los estudiantes la rinden desde el computador y tú recibes un informe con las desviaciones estándar.",
              img: img("graph.svg"),
            },
            {
              name: "Banco de materiales",
              description:
                "Materiales interactivos ordenados por curso, diagnóstico, tipo, función y profesión. Escoge los que más te gusten y aplícalos directamente con tus estudiantes.",
              img: img("image-red.svg"),
            },
            {
              name: "Planificaciones DUA",
              description:
                "Planifica en línea y en simultáneo cada curso siguiendo el decreto 83, o carga tu propio formato. Con estrategias diversificadas y acceso a todos los objetivos de aprendizaje.",
              img: img("file-blue.svg"),
            },
            {
              name: "Objetivos de Aprendizaje",
              description:
                "Todos los OA actualizados y priorizados a disposición del equipo, junto a párrafos frecuentes de los informes. No pierdas tiempo escribiéndolos.",
              img: img("file-green.svg"),
            },
            {
              name: "Cápsulas",
              description:
                "Guarda cápsulas de asignatura y de trabajo NEE ordenadas por curso. Pega links de YouTube y reprodúcelas desde la plataforma, disponibles para todo el equipo.",
              img: img("file-video.svg"),
            },
          ],
        },
        {
          name: "Gestión y colaboración del equipo",
          color: "#7d4bd0",
          services: [
            {
              name: "Monitoreo y registro de actividades",
              description:
                "Coordinadores, directores, jefes UTP y sostenedores revisan en detalle el avance de todos los documentos y la actividad de sus equipos para planificar los procesos.",
              img: img("bell.svg"),
            },
            {
              name: "Gestión del equipo y horarios",
              description:
                "Agrega o quita miembros, asigna permisos y arma los horarios en línea. El sistema verifica que cada curso cumpla las horas exigidas de apoyo y planificación.",
              img: img("calendar-check.svg"),
            },
            {
              name: "Archivos compartidos",
              description:
                "Crea carpetas y subcarpetas compartidas con tu equipo para resguardar materiales y archivos importantes, organizados por curso y profesional.",
              img: img("folder.svg"),
            },
            {
              name: "Videollamadas",
              description:
                "Reúnete con tu equipo, apoderados o estudiantes desde la plataforma y descarga un acta de registro para conservar la evidencia del trabajo remoto.",
              img: img("videocall.svg"),
            },
            {
              name: "Carga automática",
              description:
                "Toda la información de los estudiantes se carga automáticamente desde SIGE y tu nómina PIE. Tras la capacitación, empiezas a usar la plataforma sin configurar datos.",
              img: img("add-user.svg"),
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.services-wrap {
  background: #f5f8fa;
  padding: 4rem 0 4.5rem;
}
.services-head {
  max-width: 720px;
  margin: 0 auto 2.5rem;
}
.services-eyebrow {
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.8rem;
  font-weight: 700;
  color: #e0a800;
  margin-bottom: 0.6rem;
}
.services-title {
  font-weight: 800;
  color: #23303a;
  font-size: clamp(1.6rem, 3.5vw, 2.4rem);
  margin-bottom: 0.75rem;
}
.services-subtitle {
  color: #5b6b78;
  font-size: 1.05rem;
  line-height: 1.5;
  margin: 0;
}
.services-group {
  margin-top: 2.5rem;
}
.group-label {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-weight: 700;
  color: #33414d;
  font-size: 1.05rem;
  margin-bottom: 1rem;
  padding-left: 0.25rem;
}
.group-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--accent);
}
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.1rem;
}
.service-card {
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem 1.35rem;
  border-top: 4px solid var(--accent);
  box-shadow: 0 4px 18px rgba(35, 48, 58, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 14px 30px rgba(35, 48, 58, 0.12);
}
.service-icon {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--accent) 12%, #fff);
  margin-bottom: 1rem;
}
.service-icon img {
  height: 34px;
  width: 34px;
}
.service-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #23303a;
  margin-bottom: 0.5rem;
}
.service-desc {
  font-size: 0.9rem;
  line-height: 1.45;
  color: #6a7783;
  margin: 0;
}
</style>
